import { LlmProvider } from '../types'
import { anthropicProvider } from './anthropic'
import { openaiProvider } from './openai'
import { geminiProvider } from './gemini'

export const providers: { [id: string]: LlmProvider } = {
	openai: openaiProvider,
	anthropic: anthropicProvider,
	//gemini: geminiProvider,
}

export const providerList: LlmProvider[] = Object.values(providers)

export function getProvider(id: string): LlmProvider {
	const p = providers[id]
	if (!p) throw new Error('Unknown AI provider: ' + id)
	return p
}
